import { useDispatch } from "react-redux";
import PengisianMinyakMain from "../../features/pengisian-minyak/components/pengisian-minyak-main";
import { setLayoutDashboardTitle } from "../../store/ui-slice";
import { useEffect } from "react";

const title = "Pengisian Minyak";

const PengisianMinyakPage = (props, { className }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title }));
  }, []);

  return <PengisianMinyakMain />;
};

export default PengisianMinyakPage;
